import $ from 'jquery';
import EFOcats from '../../../js/v2/efocats.js';

class EFOcats_curves extends EFOcats {}

$(() => {
  window.efocats = new EFOcats_curves();

  let val = $('[name="room_name"]').val();

  // chageが登録されないのでintervalで対応
  const timer = setInterval(() => {
    if (val !== $('[name="room_name"]').val()) {
      val = $('[name="room_name"]').val();
      efocats.main();
      clearInterval(timer);
    }
  }, 100);
});
